document.addEventListener('DOMContentLoaded', function() {
  let selectedInstallOption = 'with'; // 'with' or 'without' installation, for materials that offer both
    // SVG markup for icon-upload.svg
    const ICON_UPLOAD_SVG = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" height="400" width="400"><rect fill="#F3F4F6" rx="16" height="64" width="64"></rect><path stroke-linejoin="round" stroke-linecap="round" stroke-width="2.5" stroke="#9CA3AF" d="M32 44V20M32 20L24 28M32 20L40 28"></path><rect fill="#9CA3AF" rx="2" height="4" width="32" y="44" x="16"></rect></svg>`;
    const zoomPopup = document.getElementById('material-zoom-popup');
    const zoomImg = document.getElementById('material-zoom-img');
    const zoomPopupClose = document.getElementById('zoom-popup-close');
    const form = document.getElementById('custom-print-form');
    const fileInput = document.getElementById('custom-print-file-input');
    const imageDataInput = document.getElementById('custom-print-image-data');
    const mainPreviewContainer = document.getElementById('main-custom-print-preview');
    const uploadSection = document.querySelector('.file-selection').closest('details');
    const materialSection = document.querySelector('.material-selection').closest('details');
    const measurementSection = document.querySelector('.measurement-selection').closest('details');
    const otherDetailsSection = document.querySelector('.other-details-selection').closest('details');
    const measurementNextBtn = document.querySelector('.measurement-next-btn');
    const container = document.querySelector('.custom-print-container');
    const progressText = document.querySelector('.custom-print-progress-text');
    const progressPercentage = document.querySelector('.progress-percentage');
    const progressStatus = document.querySelector('.progress-status');
    let progressInterval = null;
    let selectedMaterial = '';
    let selectedVariantId = null;
    let selectedBasePrice = 0; // This is now price per square meter
  
    // Function to close a details element
    function closeDetails(element) {
      if (element && element.hasAttribute('open')) {
        element.removeAttribute('open');
      }
    }
  
    // Function to open a details element
    function openDetails(element) {
      if (element) {
        element.setAttribute('open', '');
      }
    }
  
    // Function to upload file to Laravel backend
    async function uploadFileToLaravel(file) {
      const formData = new FormData();
      formData.append('image', file);
  
      try {
        const response = await fetch('https://printrie.murtaza.pw/api/v1/upload-to-shopify', {
          method: 'POST',
          body: formData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
  
        const data = await response.json();
  
        if (response.ok && data.fileId) {
          // Wait 2 seconds, then call the preview endpoint
          await new Promise(resolve => setTimeout(resolve, 2000));
          const previewResponse = await fetch('https://printrie.murtaza.pw/api/v1/shopify/image-preview', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ id: data.fileId })
          });
          const previewData = await previewResponse.json();
          if (previewResponse.ok && previewData.fileUrl) {
            return previewData.fileUrl;
          } else {
            throw new Error(previewData.message || 'Failed to get image preview URL');
          }
        } else if (response.ok && data.fileUrl) {
          // fallback for old response
          return data.fileUrl;
        } else {
          console.error('Error uploading file:', data.error);
          throw new Error(data.error || 'Upload failed');
        }
      } catch (error) {
        console.error('Upload error:', error);
        throw error;
      }
    }
        
    // Function to format price according to store's currency
    function formatMoney(amount) {
      // Always show as Dhs (UAE Dirham)
      // Format with 2 decimals and append ' Dhs' (no AED or symbol)
      return amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' Dhs';
    }
  
    // Function to convert measurements to meters for consistent calculation
    function convertToMeters(value, unit) {
      const conversions = {
        'cm': 0.01,    // 1 cm = 0.01 m
        'mm': 0.001,   // 1 mm = 0.001 m
        'm': 1,        // 1 m = 1 m
        'inch': 0.0254, // 1 inch = 0.0254 m
        'foot': 0.3048  // 1 foot = 0.3048 m
      };
      return value * (conversions[unit] || 1);
    }
  
    // Function to calculate quantity and price based on size (per square meter pricing)
    function calculateQuantityAndPrice(width, height, widthUnit, heightUnit, pricePerSqMeter) {
      // Convert measurements to meters
      const widthM = convertToMeters(width, widthUnit);
      const heightM = convertToMeters(height, heightUnit);
      
      // Calculate area in square meters
      let areaSqMeters = widthM * heightM;
      // If area is less than 1, charge for 1m^2
      const chargeableArea = areaSqMeters < 1 ? 1 : areaSqMeters;

      // Calculate total price based on area, with minimum 1m^2, and add 150 customization fee
      const totalPrice = (chargeableArea * pricePerSqMeter) + 150;

      // For quantity, we'll use 1 as base since we're calculating by area
      // You can adjust this logic if you need different quantity calculation
      const quantity = Math.max(1, Math.ceil(areaSqMeters));

      return {
        quantity: quantity,
        totalPrice: totalPrice,
        areaSqMeters: areaSqMeters,
        pricePerSqMeter: pricePerSqMeter,
        chargeableArea: chargeableArea
      };
    }
  
    // Handle form submission
    form.addEventListener('submit', async function(e) {
      e.preventDefault();
  
      // Validate form
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
  
      if (!selectedVariantId) {
        alert('Please select a material');
        return;
      }
  
      try {
        // Get the image file
        const imageFile = fileInput.files[0];
        if (!imageFile) {
          alert('Please select an image');
          return;
        }
  
        // Show progress text and set busy cursor
        progressText.style.display = 'block';
        progressPercentage.textContent = '0%';
        progressStatus.textContent = 'Preparing upload...';
        progressText.style.setProperty('--progress-width', '0%');
        document.body.classList.add('busy-cursor');
        let progress = 0;
        progressInterval = setInterval(() => {
          progress = Math.min(progress + Math.random() * 15, 85);
          progressPercentage.textContent = Math.round(progress) + '%';
          progressText.style.setProperty('--progress-width', progress + '%');
          if (progress < 30) {
            progressStatus.textContent = 'Uploading image...';
          } else if (progress < 60) {
            progressStatus.textContent = 'Processing image...';
          } else if (progress < 85) {
            progressStatus.textContent = 'Preparing order...';
          }
        }, 300);
  
        // Show loading state
        const submitButton = form.querySelector('button[type="submit"]');
        const originalButtonText = submitButton.textContent;
        submitButton.textContent = 'Uploading image...';
        submitButton.disabled = true;
  
        // Upload image to Laravel backend and get Shopify URL
        const customImageURL = await uploadFileToLaravel(imageFile);
  
        // Update progress to 90%
        progressPercentage.textContent = '90%';
        progressStatus.textContent = 'Adding to cart...';
        progressText.style.setProperty('--progress-width', '90%');
        clearInterval(progressInterval);
  
        // Update loading text
        submitButton.textContent = 'Processing order...';
  
        // Store the image data in the hidden input
        imageDataInput.value = customImageURL;
  
        // Get measurement values and units
        const width = parseFloat(document.querySelector('#custom-print-width').value);
        const widthUnit = document.querySelector('#custom-print-width-unit').value;
        const height = parseFloat(document.querySelector('#custom-print-height').value);
        const heightUnit = document.querySelector('#custom-print-height-unit').value;
  
        // Calculate quantity and price
        const calculation = calculateQuantityAndPrice(
          width, height, widthUnit, heightUnit, selectedBasePrice
        );
  
        // Prepare cart item data with calculated quantity
        const cartItem = {
          items: [{
            id: selectedVariantId,
            quantity: calculation.quantity,
            properties: {
              'Material': selectedMaterial,
              'Width': `${width} ${widthUnit}`,
              'Height': `${height} ${heightUnit}`,
              'Area (m²)': `${calculation.areaSqMeters.toFixed(4)} m²`,
              'Price per m²': formatMoney(calculation.pricePerSqMeter),
              'Additional Notes': document.querySelector('.custom-print-textarea').value || 'No additional notes',
              '_custom_print_image': customImageURL,
              '_calculated_price': calculation.totalPrice.toFixed(2),
              '_calculated_quantity': calculation.quantity.toString(),
              '_area_square_meters': calculation.areaSqMeters.toFixed(4)
            }
          }],
          attributes: {
            'custom_print_image_url': customImageURL // Add image URL as cart attribute
          }
        };
  
        // Add to cart
        const cartResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(cartItem)
        });
  
        if (!cartResponse.ok) {
          const errorData = await cartResponse.json();
          throw new Error(errorData.description || 'Failed to add item to cart');
        }
  
        // Set progress to 100% before redirect
        progressPercentage.textContent = '100%';
        progressStatus.textContent = 'Success! Redirecting...';
        progressText.style.setProperty('--progress-width', '100%');
  
        // Redirect to cart page
        window.location.href = '/cart';
  
      } catch (error) {
        console.error('Error:', error);
        alert(error.message || 'There was an error processing your order. Please try again.');
  
        // Reset button state
        submitButton.textContent = originalButtonText;
        submitButton.disabled = false;
        // Hide progress text and reset cursor
        progressText.style.display = 'none';
        document.body.classList.remove('busy-cursor');
        if (progressInterval) clearInterval(progressInterval);
      }
    });
  
    // Handle measurement inputs
    const measurementInputs = document.querySelectorAll('.custom-print-measurement-input');
    measurementInputs.forEach(input => {
      input.addEventListener('input', function() {
        // Remove error state when user starts typing
        this.classList.remove('error');
        const errorElement = this.parentElement.querySelector('.error-message');
        if (errorElement) {
          errorElement.classList.remove('show');
        }
        updatePrice();
      });
    });
  
    // Handle unit changes
    const unitSelects = document.querySelectorAll('.custom-print-unit-select');
    unitSelects.forEach(select => {
      select.addEventListener('change', function() {
        updatePrice();
      });
    });
  
    // Handle Next button click
    measurementNextBtn.addEventListener('click', function() {
      // Validate measurements before proceeding
      const width = document.querySelector('#custom-print-width').value;
      const height = document.querySelector('#custom-print-height').value;
  
      // Reset previous validation state
      const widthInput = document.querySelector('#custom-print-width');
      const heightInput = document.querySelector('#custom-print-height');
      const widthError = document.querySelector('#width-error');
      const heightError = document.querySelector('#height-error');
      
      widthInput.classList.remove('error');
      heightInput.classList.remove('error');
      widthError.classList.remove('show');
      heightError.classList.remove('show');

      let hasError = false;

      if (!width) {
        widthInput.classList.add('error');
        widthError.classList.add('show');
        hasError = true;
      }

      if (!height) {
        heightInput.classList.add('error');
        heightError.classList.add('show');
        hasError = true;
      }

      if (hasError) {
        return;
      }
  
      // Close measurement section and open other details section
      closeDetails(measurementSection);
      openDetails(otherDetailsSection);
    });
  
    // Remove any existing remove button before adding a new one
    function removeImageRemoveButton() {
      const btn = mainPreviewContainer.querySelector('.custom-print-image-remove');
      if (btn) btn.remove();
    }

    // Add remove button to the preview image
    function addImageRemoveButton() {
      removeImageRemoveButton();
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'custom-print-image-remove';
      btn.innerHTML = '&times;';
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        // Reset preview to default icon
        mainPreviewContainer.innerHTML = ICON_UPLOAD_SVG;
        fileInput.value = '';
        document.getElementById('custom-file-upload-filename').textContent = 'No file chosen';
        mainPreviewContainer.parentElement.classList.remove('has-image');
      });
      mainPreviewContainer.appendChild(btn);
      mainPreviewContainer.style.position = 'relative';
    }

    fileInput.addEventListener('change', function(e) {
      const file = e.target.files[0];
      const errorDiv = document.getElementById('file-size-error');
      const fileNameSpan = document.getElementById('custom-file-upload-filename');
      if (file) {
        fileNameSpan.textContent = file.name;
        if (file.size > 5 * 1024 * 1024) { // 5MB
          errorDiv.style.display = 'block';
          fileInput.value = '';
          fileNameSpan.textContent = 'No file chosen';
          return;
        } else {
          errorDiv.style.display = 'none';
        }
        const reader = new FileReader();
        reader.onload = function(e) {
          // Create new img element if it doesn't exist
          let imgElement = mainPreviewContainer.querySelector('img');
          if (!imgElement) {
            imgElement = document.createElement('img');
            imgElement.className = 'custom-print-image';
            imgElement.width = 600;
            imgElement.alt = 'Custom Print Example';
            imgElement.style.height = 'auto';
            imgElement.style.objectFit = 'contain';
            mainPreviewContainer.innerHTML = '';
            mainPreviewContainer.appendChild(imgElement);
          }
          imgElement.src = e.target.result;
          mainPreviewContainer.parentElement.classList.add('has-image');
          addImageRemoveButton();
          // Close upload section and open material section
          closeDetails(uploadSection);
          openDetails(materialSection);
        };
        reader.readAsDataURL(file);
      } else {
        removeImageRemoveButton();
      }
    });
  
    // Handle material selection
    const materialCards = document.querySelectorAll('.custom-material-card');
    const selectMaterialBtns = document.querySelectorAll('.select-material-btn');
    selectMaterialBtns.forEach((btn, idx) => {
      btn.addEventListener('click', function(e) {
        // Remove active from all
        materialCards.forEach(card => card.classList.remove('active'));
        // Add active to this card
        const card = btn.closest('.custom-material-card');
        card.classList.add('active');
        // Store selected material and variant ID
        selectedMaterial = card.querySelector('.material-card-title').textContent;
        selectedVariantId = card.dataset.variantId;
        selectedBasePrice = parseFloat(card.dataset.basePrice);
        selectedInstallOption = card.querySelector('.install-option-btn') ? (card.dataset.installOption || 'with') : null;
        updatePrice();
        // Close material section and open measurement section
        closeDetails(materialSection);
        openDetails(measurementSection);
      });
    });
    // Handle with/without installation price toggle
    document.querySelectorAll('.install-option-btn').forEach(optBtn => {
      optBtn.addEventListener('click', function(e) {
        const card = optBtn.closest('.custom-material-card');
        card.querySelectorAll('.install-option-btn').forEach(b => b.classList.remove('active'));
        optBtn.classList.add('active');
        const price = parseFloat(optBtn.dataset.price);
        card.dataset.basePrice = price;
        card.dataset.variantPrice = price;
        card.dataset.installOption = optBtn.dataset.install;
        if (selectedVariantId === card.dataset.variantId) {
          selectedBasePrice = price;
          selectedInstallOption = optBtn.dataset.install;
          updatePrice();
        }
      });
    });
  
    // Function to update price display
    function updatePrice() {
      const width = parseFloat(document.querySelector('#custom-print-width').value) || 0;
      const height = parseFloat(document.querySelector('#custom-print-height').value) || 0;
      const widthUnit = document.querySelector('#custom-print-width-unit').value;
      const heightUnit = document.querySelector('#custom-print-height-unit').value;

      // Get table rows and cells
      const materialRow = document.querySelector('.price-table-row-material');
      const measurementRow = document.querySelector('.price-table-row-measurement');
      const areaRow = document.querySelector('.price-table-row-area');
      const minChargeNoteRow = document.querySelector('.price-table-row-min-charge-note');
      const unitPriceRow = document.querySelector('.price-table-row-unit-price');
      const subtotalRow = document.querySelector('.price-table-row-subtotal');
      const feeRow = document.querySelector('.price-table-row-fee');
      
      const selectedMaterialCell = document.querySelector('.selected-material-name');
      const selectedMeasurementCell = document.querySelector('.selected-measurement');
      const totalAreaCell = document.querySelector('.total-area');
      const unitPriceCell = document.querySelector('.price-unit');
      const subtotalCell = document.querySelector('.subtotal-price');
      const finalPriceCell = document.querySelector('.final-price');


      // Update selected material name display
      if (selectedMaterial && selectedMaterialCell) {
        selectedMaterialCell.textContent = selectedMaterial;
        unitPriceRow.style.display = '';
        feeRow.style.display = '';
      } else if (selectedMaterialCell) {
        selectedMaterialCell.textContent = 'None';
        unitPriceRow.style.display = 'none';
        feeRow.style.display = 'none';
      }

      // Update selected measurement display
      if (width && height && selectedMeasurementCell) {
        selectedMeasurementCell.textContent = `${width} ${widthUnit} x ${height} ${heightUnit}`;
        measurementRow.style.display = '';
        subtotalRow.style.display = '';
        areaRow.style.display = '';
      } else if (selectedMeasurementCell) {
        selectedMeasurementCell.textContent = 'N/A';
        measurementRow.style.display = 'none';
        subtotalRow.style.display = 'none';
        areaRow.style.display = 'none';
        minChargeNoteRow.style.display = 'none';
      }
  
      if (width && height && selectedBasePrice) {
        const calculation = calculateQuantityAndPrice(
          width, height, widthUnit, heightUnit, selectedBasePrice
        );
  
        const formattedPrice = formatMoney(calculation.totalPrice);
  
        // Update price display cells
        if (finalPriceCell) {
          finalPriceCell.innerHTML = `<strong>${formattedPrice}</strong>`;
        }
        if (totalAreaCell) {
            totalAreaCell.textContent = `${calculation.areaSqMeters.toFixed(2)} m²`;
        }
        if (calculation.areaSqMeters < 1) {
            minChargeNoteRow.style.display = '';
        } else {
            minChargeNoteRow.style.display = 'none';
        }
        if (subtotalCell) {
            const subtotal = calculation.totalPrice - 150;
            subtotalCell.textContent = formatMoney(subtotal);
        }

        if (unitPriceCell) {
            unitPriceCell.textContent = formatMoney(selectedBasePrice) + '/m²';
        }
  
        // Update button price
        const buttonPrice = document.querySelector('.button-price');
        if (buttonPrice) {
          buttonPrice.textContent = formattedPrice;
        }
  
        // Update material button prices to show price difference
        materialCards.forEach(card => {
          const pricePerSqMeter = parseFloat(card.dataset.basePrice);
          const materialCalculation = calculateQuantityAndPrice(
            width, height, widthUnit, heightUnit, pricePerSqMeter
          );
          const priceSpan = card.querySelector('.material-price');
          if (priceSpan) {
            priceSpan.innerHTML = `
              ${formatMoney(materialCalculation.totalPrice)}
            `;
          }
        });
      } else if (selectedBasePrice) {
        // If no measurements but material is selected, show price per square meter
        const formattedPrice = formatMoney(selectedBasePrice + 150);
        const buttonPrice = document.querySelector('.button-price');
  
        if (finalPriceCell) {
          finalPriceCell.innerHTML = `<strong>${formattedPrice}</strong>`;
        }
        if (unitPriceCell) {
            unitPriceCell.textContent = formatMoney(selectedBasePrice) + '/m²';
        }
        if (subtotalCell) {
            subtotalCell.textContent = formatMoney(selectedBasePrice);
        }
        if (buttonPrice) {
          buttonPrice.textContent = `from ${formattedPrice}`;
        }
      } else {
        // Reset if no material selected
        if (finalPriceCell) {
            finalPriceCell.innerHTML = `<strong>${formatMoney(0)}</strong>`;
        }
        if (totalAreaCell) {
            totalAreaCell.textContent = 'N/A';
        }
        if (unitPriceCell) {
            unitPriceCell.textContent = 'N/A';
        }
        if (subtotalCell) {
            subtotalCell.textContent = formatMoney(0);
        }
        const buttonPrice = document.querySelector('.button-price');
        if (buttonPrice) {
            buttonPrice.textContent = formatMoney(0);
        }
      }
    }

    // Image Zoom
    document.querySelectorAll('.zoomable-material-image').forEach(function(img) {
      img.addEventListener('click', function(e) {
        const url = new URL(img.src, window.location.origin);
        url.searchParams.set('width', '500');
        zoomImg.src = url.toString();
        zoomPopup.style.display = 'block';
      });
    });

    // Add close logic for zoom popup
    if (zoomPopupClose) {
      zoomPopupClose.addEventListener('click', function(e) {
        zoomPopup.style.display = 'none';
        zoomImg.src = '';
      });
    }
    // Close popup when clicking outside the image
    zoomPopup.addEventListener('click', function(e) {
      if (e.target === zoomPopup) {
        zoomPopup.style.display = 'none';
        zoomImg.src = '';
      }
    });

    const sendInquiryButton = document.querySelector('.send-inquiry-button');
    sendInquiryButton.addEventListener('click', async function(e) {
      e.preventDefault();
      // Custom validation for file input
      const fileError = document.getElementById('file-required-error');
      const fileAccordion = document.querySelector('.file-selection').closest('details');
      if (!fileInput.files[0]) {
        fileError.style.display = 'block';
        fileAccordion.open = true;
        fileAccordion.scrollIntoView({behavior: 'smooth', block: 'center'});
        return;
      } else {
        fileError.style.display = 'none';
      }
      // Custom validation for material selection
      const materialError = document.getElementById('material-required-error');
      const materialAccordion = document.querySelector('.material-selection').closest('details');
      if (!selectedVariantId) {
        materialError.style.display = 'block';
        materialAccordion.open = true;
        materialAccordion.scrollIntoView({behavior: 'smooth', block: 'center'});
        return;
      } else {
        materialError.style.display = 'none';
      }
      // Custom validation for measurement fields
      const widthInput = document.querySelector('#custom-print-width');
      const heightInput = document.querySelector('#custom-print-height');
      const widthError = document.querySelector('#width-error');
      const heightError = document.querySelector('#height-error');
      const measurementAccordion = document.querySelector('.measurement-selection').closest('details');
      let measurementHasError = false;
      if (!widthInput.value) {
        widthInput.classList.add('error');
        widthError.classList.add('show');
        measurementHasError = true;
      } else {
        widthInput.classList.remove('error');
        widthError.classList.remove('show');
      }
      if (!heightInput.value) {
        heightInput.classList.add('error');
        heightError.classList.add('show');
        measurementHasError = true;
      } else {
        heightInput.classList.remove('error');
        heightError.classList.remove('show');
      }
      if (measurementHasError) {
        measurementAccordion.open = true;
        measurementAccordion.scrollIntoView({behavior: 'smooth', block: 'center'});
        return;
      }
      // Let browser handle the rest (contact fields)
      if (!form.checkValidity()) {
        // Find the first invalid element and open its accordion
        const firstInvalid = form.querySelector(':invalid');
        if (firstInvalid) {
          const details = firstInvalid.closest('details.accordion');
          if (details) {
            details.open = true;
            details.scrollIntoView({behavior: 'smooth', block: 'center'});
          }
        }
        form.reportValidity();
        return;
      }

      // --- Inquiry submission logic ---
      const sendInquiryButton = e.target;
      const originalButtonText = sendInquiryButton.textContent;
      sendInquiryButton.disabled = true;
      sendInquiryButton.textContent = 'Sending...';
      document.body.classList.add('busy-cursor');

      // Gather form fields 
      const width = parseFloat(document.querySelector('#custom-print-width').value);
      const widthUnit = document.querySelector('#custom-print-width-unit').value;
      const height = parseFloat(document.querySelector('#custom-print-height').value);
      const heightUnit = document.querySelector('#custom-print-height-unit').value;
      const message = document.querySelector('#custom-print-note').value || 'No additional notes';
      const name = document.getElementById('custom-print-first-name').value +' '+ document.getElementById('custom-print-last-name').value;
      const phone = document.getElementById('phone-number').value;
      const email = document.getElementById('custom-print-email').value;
      // const message = document.getElementById('custom-print-message').value;

      // Prepare FormData for direct submission
      const formData = new FormData();
      formData.append('material', selectedMaterial + (selectedInstallOption ? (selectedInstallOption === 'without' ? ' (without installation)' : ' (with installation)') : ''));
      formData.append('variant_id', selectedVariantId);
      formData.append('width', `${width} ${widthUnit}`);
      formData.append('height', `${height} ${heightUnit}`);
      // formData.append('notes', notes);
      formData.append('image', fileInput.files[0]); // Attach the file directly
      formData.append('name', name);
      formData.append('phone', phone);
      formData.append('email', email);
      formData.append('message', message);

      try {
        const response = await fetch('https://printrie.murtaza.pw/api/v1/inquiry', {
          method: 'POST',
          body: formData
          // Do NOT set Content-Type; browser will set it to multipart/form-data
        });

        if (!response.ok) {
          throw new Error('Failed to send inquiry');
        }

        showCustomPrintMessage('Inquiry sent successfully!', 'success');
        // Tracking: fire Lead only after the inquiry was successfully sent
        try { if (typeof window.fbq === 'function') { window.fbq('track', 'Lead', { content_name: 'Custom Wallpaper Inquiry', content_category: 'Custom Wallpaper' }); } if (typeof window.gtag === 'function') { window.gtag('event', 'generate_lead', { form_name: 'custom_wallpaper_inquiry' }); } } catch (trackingError) { console.warn('Lead tracking failed', trackingError); }
        
        // Optionally reset the form or show a success message
        form.reset();
        // Reset preview image, etc.
        if (mainPreviewContainer) {
          mainPreviewContainer.innerHTML = ICON_UPLOAD_SVG;
        }
      } catch (error) {
        showCustomPrintMessage('Error sending inquiry: ' + (error.message || 'Unknown error'), 'error');
      } finally {
        sendInquiryButton.disabled = false;
        sendInquiryButton.textContent = originalButtonText;
        document.body.classList.remove('busy-cursor');
      }
    });

    // Helper to show messages
    function showCustomPrintMessage(msg, type) {
      const msgDiv = document.getElementById('custom-print-message');
      if (!msgDiv) return;
      msgDiv.textContent = msg;
      msgDiv.style.display = 'block';
      msgDiv.style.background = type === 'success' ? '#2e7d2e' : '#d32f2f';
      setTimeout(() => { msgDiv.style.display = 'none'; }, 5000);
    }

    // Prevent non-numeric input for UAE phone number field
    const phoneInput = document.getElementById('phone-number');
    if (phoneInput) {
      phoneInput.addEventListener('input', function(e) {
        // Remove any non-digit character
        this.value = this.value.replace(/[^0-9]/g, '');
      });
    }

    // Trigger file input when preview image is clicked
    mainPreviewContainer.addEventListener('click', function() {
      fileInput.click();
    });
}); 